"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FontAwesomeContext = _interopRequireDefault(require("../FontAwesomeContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FeIcon = function FeIcon(_ref) {
  var icon = _ref.icon,
      family = _ref.family,
      spin = _ref.spin,
      className = _ref.className;
  return _react.default.createElement(_FontAwesomeContext.default.Consumer, null, function (_ref2) {
    var Icon = _ref2.Icon;
    return _react.default.createElement(Icon, {
      icon: icon,
      family: family,
      spin: spin,
      className: className
    });
  });
};

FeIcon.defaultProps = {
  family: 'regular',
  spin: false
};
FeIcon.propTypes = {
  /** The icon name */
  icon: _propTypes.default.string.isRequired,

  /** The Icon family. Can be regular, solid, light, or brand */
  family: _propTypes.default.oneOf(['regular', 'solid', 'light', 'brand']),

  /** Whether or not the icon should spin */
  spin: _propTypes.default.bool
};
FeIcon.displayName = 'FeIcon';
var _default = FeIcon;
exports.default = _default;